"use client";

import { c as _c } from "react/compiler-runtime";
import { formatHref, isExternalLink, Link } from "@opensea/ui-kit";
import { createContext, useCallback, useContext } from "react";
import { FlowActions } from "../stores/flowStore";
const NavigationContext = createContext({
  renderLink: DefaultLink
});
export function NavigationProvider(t0) {
  const $ = _c(5);
  const {
    children,
    renderLink: t1
  } = t0;
  const renderLink = t1 === undefined ? DefaultLink : t1;
  let t2;
  if ($[0] !== renderLink) {
    t2 = {
      renderLink
    };
    $[0] = renderLink;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children || $[3] !== t2) {
    t3 = <NavigationContext.Provider value={t2}>{children}</NavigationContext.Provider>;
    $[2] = children;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export function useNavigation() {
  const $ = _c(2);
  const {
    renderLink
  } = useContext(NavigationContext);
  const onClick = _temp;
  let t0;
  if ($[0] !== renderLink) {
    t0 = {
      renderLink,
      onClick
    };
    $[0] = renderLink;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp(e) {
  const href = e.currentTarget.href;
  if (href) {
    FlowActions.endFlow();
  }
}
const OS_SITE_URL = "https://os2-web.prod.privatesea.io";
export function DefaultLink(t0) {
  const $ = _c(12);
  let href;
  let restProps;
  if ($[0] !== t0) {
    ({
      href,
      ...restProps
    } = t0);
    $[0] = t0;
    $[1] = href;
    $[2] = restProps;
  } else {
    href = $[1];
    restProps = $[2];
  }
  if (!href) {
    let t1;
    if ($[3] !== restProps) {
      t1 = <Link rel="noopener" {...restProps} target="_blank" />;
      $[3] = restProps;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    return t1;
  }
  let t1;
  let url;
  if ($[5] !== href || $[6] !== restProps) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      url = formatHref(href);
      if (!isExternalLink(href)) {
        const pathname = new URL(url, OS_SITE_URL);
        t1 = <Link href={pathname.toString()} rel="noopener" {...restProps} target="_blank" />;
        break bb0;
      }
    }
    $[5] = href;
    $[6] = restProps;
    $[7] = t1;
    $[8] = url;
  } else {
    t1 = $[7];
    url = $[8];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  let t2;
  if ($[9] !== restProps || $[10] !== url) {
    t2 = <Link href={url} rel="noopener" {...restProps} target="_blank" />;
    $[9] = restProps;
    $[10] = url;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
}